module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d4157dc0bf91a25fd4177a364647132f.png";